
import { defineComponent } from 'vue';
import { IUpdate } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/v7';

interface IState {
  stable?: IUpdate;
  nightly?: IUpdate;
  updates?: IUpdate[];
}

export default defineComponent({
  data() {
    return {
      stable: undefined,
      nightly: undefined,
      updates: undefined,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.stable = res.stable;
        this.nightly = res.nightly;
        this.updates = res.updates;
      });
    },

    apiAdd(version: string) {
      api.add(
        {
          version,
        },
        (res) => {
          this.stable = res.stable;
          this.nightly = res.nightly;
          this.updates = res.updates;
        },
      );
    },

    apiDelete(updateId: number) {
      api.delete(
        {
          updateId,
        },
        (res) => {
          this.stable = res.stable;
          this.nightly = res.nightly;
          this.updates = res.updates;
        },
      );
    },

    btnAddClick() {
      utils.prompt(
        {
          title: '提示',
          message: '请输入版本号',
        },
        (value) => {
          this.apiAdd(value);
        },
      );
    },

    btnDeleteClick(updateId: number, version: string) {
      utils.alertDelete(
        {
          title: `此操作将删除版本 ${version}，确定吗？`,
        },
        () => {
          this.apiDelete(updateId);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
